/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocationDetailsViewModel } from './locationDetailsViewModel';
import { CodeViewModel } from './codeViewModel';
import { ProviderDetailsViewModel } from './providerDetailsViewModel';

export interface DatasetDetailsViewModel {
  id?: string;
  isDeleted?: boolean;
  name?: string | null;
  acronym?: string | null;
  taxIdNumber?: string | null;
  address1?: string | null;
  address2?: string | null;
  city?: string | null;
  stateCode?: string | null;
  zip?: string | null;
  countryCode?: string | null;
  phoneNumber?: string | null;
  taxonomy?: string | null;
  npi?: string | null;
  stateLicenseNumber?: string | null;
  mailingName?: string | null;
  mailingAddress1?: string | null;
  mailingAddress2?: string | null;
  mailingCity?: string | null;
  mailingStateCode?: string | null;
  mailingZip?: string | null;
  mailingCountryCode?: string | null;
  websiteUrl?: string | null;
  contactEmailAddress?: string | null;
  personEntity?: boolean;
  billingProviderLastOrgName?: string | null;
  billingProviderFirstName?: string | null;
  billingProviderMiddleName?: string | null;
  billingProviderSuffix?: string | null;
  billingProviderNPI?: string | null;
  maxDelinquencyCode?: number;
  defaultPwkReportTypeCode?: string | null;
  defaultPwkTransmissionCode?: string | null;
  deptOfLaborProviderId?: string | null;
  inactive?: boolean;
  monthCloseDate?: string | null;
  sequence?: number;
  printHcfaImage?: boolean;
  imaginePayActive?: boolean;
  imaginePayPaymentCode?: string | null;
  imaginePayPaymentCodeDisplay?: string | null;
  imaginePayRefundPaymentCodeDisplay?: string | null;
  defaultLocationId?: string | null;
  defaultLocationDisplay?: string | null;
  defaultAttendingProviderId?: string | null;
  defaultAttendingProviderDisplay?: string | null;
  defaultPlaceOfServiceId?: string | null;
  defaultPlaceOfServiceDisplay?: string | null;
  defaultReferringProviderId?: string | null;
  defaultReferringProviderDisplay?: string | null;
  defaultLocation?: LocationDetailsViewModel;
  defaultPlaceOfService?: CodeViewModel;
  defaultAttendingProvider?: ProviderDetailsViewModel;
  defaultReferringProvider?: ProviderDetailsViewModel;
  accountNumberType?: string | null;
  institutionalBilling?: boolean;
  defaultEligibilityType?: string | null;
  defaultEligibilityTypeDisplay?: string | null;
  checkEligWithoutVisit?: boolean;
  automatedCardProcessing?: boolean;
  imaginePayRefundPaymentCodeId?: string | null;
  maxEligibilityRequests?: number;
  hasEligConfig?: boolean;
  showPatientEstimates?: boolean;
  allowAutopayZero?: boolean;
}
